var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "shop_brands_inner" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "left" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.value.config.name)),
        ]),
      ]),
      _vm._m(0),
    ]),
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "el-row",
          { staticClass: "myRow", attrs: { gutter: 5 } },
          _vm._l(_vm.brandList, function (item) {
            return _c(
              "el-col",
              { key: item.id, staticClass: "brand", attrs: { span: 6 } },
              [
                _c("el-image", {
                  staticClass: "img",
                  attrs: { src: item.brand_logo, fit: "contain" },
                }),
              ],
              1
            )
          }),
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right" }, [
      _vm._v(" 更多 "),
      _c("i", { staticClass: "el-icon el-icon-arrow-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }